/*
 * Public API Surface of autocomplete-lib
 */

export * from './lib/autocomplete-lib.module';
export * from './lib/autocomplete.component';
export * from './lib/highlight.pipe';

